import React from "react";
import { Alert, Button } from "react-bootstrap";
import { EditBillableItem } from ".";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, BillableItemInterface, InvoiceInterface, UserHelper } from "../../helpers";
interface Props {

}

export const BillableItems: React.FC<Props> = props => {
  const [cancelling, setCancelling] = React.useState(false);
  const [cancelled, setCancelled] = React.useState(false);
  const [billableItems, setBillableItems] = React.useState<BillableItemInterface[]>(null);
  const [selectedItem, setSelectedItem] = React.useState<BillableItemInterface>(null);

  const init = () => {
    ApiHelper.get<BillableItemInterface[]>("/billableItems/currentAndUpcoming").then((data) => setBillableItems(data || []));
  }

  React.useEffect(init, [])


  const getTable = () => {
    if (billableItems === null) return <Loading />
    else {
      if (billableItems.length === 0) return <p>There are no current subscriptions</p>
      else {
        const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

        const rows: React.ReactElement[] = [];
        billableItems.forEach(bi => {

          const item = bi;
          const nameEl = (UserHelper.checkAccess("admin"))
            ? <a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedItem(item) }}>{bi.name}</a>
            : <>{bi.name}</>

          rows.push(<tr>
            <td>{nameEl}</td>
            <td>{formatter.format(bi.monthlyRate)}</td>
          </tr>)

        });
        return (<table className="table table-sm table-striped">
          <thead>
            <tr><th>Name</th><th>Price</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>)
      }
    }
  }

  const getTotal = () => {
    const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    let result = 0;
    billableItems?.forEach(bi => {
      result += bi.monthlyRate;
    });
    return <div className="text-success">{formatter.format(result).replace(".00", "")}/month</div>;
  }

  const getCancel = () => {
    let total = 0;
    billableItems?.forEach(bi => { total += bi.monthlyRate; });
    if (total > 0) {
      return <Button variant="danger" className="d-grid" style={{ width: "100%" }} onClick={handleCancel} disabled={cancelling} >Cancel All Subscriptions</Button>
    }
  }

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.confirm("To cancel a single screen, just go to the screen and delete it.  This button will delete all screens and feeds in all departments for this account.  Are you sure you wish to continue?")) {
      setCancelling(true);
      ApiHelper.post("/accounts/cancel", {}).then(() => {
        setCancelling(false);
        setCancelled(true);
        init();
      })
    }
  }

  const getCancelled = () => {
    if (cancelled) {
      return <Alert variant="danger"><b>Cancelled:</b> Your account has been cancelled.  No new charges will be acrued.  If there are any 'In Progress' invoices, they will be billed at the end of the month.</Alert>
    }
  }

  const getItemDetails = () => {
    if (selectedItem) return <EditBillableItem billableItem={selectedItem} onClose={() => { setSelectedItem(null); init(); }} />
  }

  return (
    <>
      {getItemDetails()}
      {getCancelled()}
      <DisplayBox editContent={getTotal()} headerText={"Current Subscriptions"} headerIcon="fas fa-credit-card" >
        {getTable()}
        {getCancel()}
      </DisplayBox>
    </>
  );
};